export default __webpack_public_path__ + "static/GreatWestern-15fcbb2091c0033b1a6c78e5552aec1b.otf";